import { useLocation } from 'react-router-dom';

export const useSearchParamsQuery = () => {
	const { search } = useLocation();
	return new URLSearchParams(search);
};
